<template>
  <asc-card flat class="asc-platform-tile" no-spacing>
    <div class="asc-platform-tile--content">
      <div class="asc-platform-tile--platform">{{ platform }}</div>
      <template v-if="signatures">
        <div class="asc-platform-tile--signatures">
          <span>{{ signatures }}</span> Total Signatures
        </div>
        <div
          v-if="lastModifiedDate.length"
          class="asc-platform-tile--lastModifiedDate"
        >
          Data Last Updated:
          <span>{{ getFormatedUTCDateTime(lastModifiedDate) }}</span>
        </div>
        <asc-accent-button
          secondary
          block
          button-text="Select"
          class="asc-platform-tile--select"
          :on-click="handlePlatFormSelect"
        ></asc-accent-button>
      </template>
      <template v-else>
        <div class="asc-platform-tile--noResults">
          <span>
            There are no analytics developer results for this platform.
          </span>
        </div>
      </template>
    </div>
  </asc-card>
</template>

<script>
import AscCard from '../atoms/AscCard.vue'
import AscAccentButton from '../atoms/AscAccentButton.vue'
import { getFormattedUTCDate } from '@/utilities/dates'

export default {
  name: 'AscPlatformTile',

  components: {
    AscCard,
    AscAccentButton,
  },

  props: {
    value: {
      type: Object,
      default: null,
    },
    platform: {
      type: String,
      required: true,
      default: '',
    },
    signatures: {
      type: Number,
      required: true,
      default: 0,
    },
    lastModifiedDate: {
      type: String,
      required: true,
      default: '',
    },
  },

  methods: {
    handlePlatFormSelect(event) {
      this.$emit('onPlatformSelect', event, this.value)
    },

    getFormatedUTCDateTime(dateTime) {
      return getFormattedUTCDate(dateTime)
    },
  },
}
</script>

<style lang="scss">
.asc-platform-tile {
  display: flex;
  height: 100%;

  &--content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    background: $primary-white;
    border: 1px solid $gray-300;
    gap: 16px;
    height: 100%;
  }

  &--platform {
    padding: 16px;
    height: 63px;
    width: 100%;
    background: $gray-0;
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 28px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: $primary-black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &--signatures {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: $gray-600;

    & > span {
      color: $primary-black;
      margin-right: 10px;
    }
  }

  &--lastModifiedDate {
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: $gray-700;
  }

  &--noResults {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: $gray-600;

    & > span {
      color: $primary-black;
      margin-right: 10px;
    }
  }

  &--select {
    width: 100%;
  }
}
</style>
